import React from 'react';
import useIsMobile from '../hooks/useIsMobile';

/**
 * Route-level switch between a desktop and a purpose-built mobile component.
 * Usage:  element={<Adaptive desktop={ProductList} mobile={MobileProductList} />}
 *
 * If no mobile variant is supplied, the desktop component is used everywhere
 * (it still renders inside the mobile shell, so nothing breaks while the mobile
 * screens are being built out one by one).
 */
export default function Adaptive({ desktop: Desktop, mobile: Mobile }) {
  const isMobile = useIsMobile();
  const Component = isMobile && Mobile ? Mobile : Desktop;
  return <Component />;
}
